import React, { useEffect} from 'react';
import { MapPin, Phone, Mail, Clock, Instagram } from 'lucide-react';
import { useToast } from '../hooks/use-toast';
import { ArrowRight, Zap, Users, Award, CheckCircle } from "lucide-react";
// import FileOrderModal from "./FileOrderModal";

const ContactPage = () => {
  // const [showOffer, setShowOffer] = useState(false);

  // useEffect(() => {
  //   const t = setTimeout(() => setShowOffer(true), 600);
  //   return () => clearTimeout(t);
  // }, []);



  const { toast } = useToast();

  useEffect(() => {
    // Dynamically load external script for iframe functionality
    const script = document.createElement('script');
    script.src = 'https://link.implantsmgmt.com/js/form_embed.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen pt-16">
         {/* <FileOrderModal open={showOffer} onClose={() => setShowOffer(false)} /> */}
              
      {/* Hero Section */}
      {/* bg-gradient-to-br from-blue-900 via-blue-900 to-slate-900 */}
      <section className="  py-20 bg-black ">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
  <h1 className="text-4xl sm:text-5xl font-bold text-white mb-6">
    Let's Talk{' '}
    <span className="text-white">
      Smiles
    </span>
  </h1>

  <p className="text-lg text-white leading-relaxed mb-8">
    Have a question, need support, or ready to start a new case? Our team at Ace Dental Lab is here to assist you. Contact us today to create something amazing.
  </p>

  <p className="text-lg text-white leading-relaxed mb-6">
    Track your cases, orders, and lab progress anytime with Magic Touch.
    Click below to connect and manage everything in one place.
  </p>

  <a
    href="https://acedentalportal.dlcpm.net/login.aspx"
    target="_blank"
    rel="noopener noreferrer"
    className="inline-flex items-center  bg-white  text-black px-8 py-4 rounded-lg font-medium"
  >
    Click Here <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
  </a>
</div>
            {/* <div className="bg-slate-900 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
              <h3 className="text-xl font-semibold text-white mb-6">Get in Touch</h3>
              <p className="text-white mb-6 leading-relaxed">
                We're here to answer your questions and guide you every step of the way. Connect with Ace Dental Lab for expert support, case inquiries, or collaboration opportunities.
              </p>

              <div className="space-y-4">
                <div className="flex items-center space-x-3">
                  <Phone className="w-5 h-5 text-gray-400 flex-shrink-0" />
                  <a href="tel:+16308661646" className="text-gray-300 hover:text-blue-400 transition-colors">
                    +1 (630) 866-1646
                  </a>
                </div>
                <div className="flex items-center space-x-3">
                  <Mail className="w-5 h-5 text-gray-400 flex-shrink-0" />
                  <a href="mailto:Lab@acedentalcenter.com" className="text-gray-300 hover:text-blue-400 transition-colors">
                    Lab2@acedentalcenter.com
                  </a>
                </div>
                <div className="flex items-start space-x-3">
                  <MapPin className="w-5 h-5 text-gray-400 mt-0.5 flex-shrink-0" />
                  <div className="text-gray-300">
                    <div>501 E Roosevelt Road</div>
                    <div>Lombard, Illinois 60148</div>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <Clock className="w-5 h-5 text-gray-400 mt-0.5 flex-shrink-0" />
                  <div className="text-gray-300">
                    <div>Mon-Fri: 8:30AM - 4:30PM</div>
                    <div>Saturday: 9:00AM - 2:00PM</div>
                  </div>
                </div>
              </div>
            </div> */}
             {/* <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
              Book Your Case
            </h2>
            <p className="text-lg text-white max-w-2xl mx-auto leading-relaxed">
              Ready to work with us? Schedule your appointment with Ace Dental Lab today. Our team is here to provide you with reliable, high-quality dental solutions tailored to your needs.
            </p>
          </div> */}
             <iframe
              src="https://link.implantsmgmt.com/widget/form/uKhczcc5b4vLRajpOEPW"
              style={{ width: '100%', height: '100%', border: 'none', borderRadius: '3px' }}
              id="inline-uKhczcc5b4vLRajpOEPW"  
              data-layout="{'id':'INLINE'}"
              data-trigger-type="alwaysShow"
              data-trigger-value=""
              data-activation-type="alwaysActivated"
              data-activation-value=""
              data-deactivation-type="neverDeactivate"
              data-deactivation-value=""
              data-form-name="Ace Dental Lab"
              data-height="571"
              data-layout-iframe-id="inline-uKhczcc5b4vLRajpOEPW"
              data-form-id="uKhczcc5b4vLRajpOEPW"
              title="Ace Dental Lab"
            ></iframe>
          </div>
        </div>
      </section>



       {/* Contact Form Section with iframe */}
      <section className="py-10 bg-black">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
              Book Your Case
            </h2>
            <p className="text-lg text-white max-w-2xl mx-auto leading-relaxed">
              Ready to work with us? Schedule your appointment with Ace Dental Lab today. Our team is here to provide you with reliable, high-quality dental solutions tailored to your needs.
            </p>
          </div> */}

          {/* ✅ Updated iframe (your version) */}
          {/* <div className="bg-gradient-to-r from-slate-50 to-blue-50 rounded-2xl p-4 border border-blue-100 shadow-sm"> */}
           
               <div className="bg-slate-900 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
              <h3 className="text-xl font-semibold text-white mb-6">Get in Touch</h3>
              <p className="text-white mb-6 leading-relaxed">
                We're here to answer your questions and guide you every step of the way. Connect with Ace Dental Lab for expert support, case inquiries, or collaboration opportunities.
              </p>

              <div className="space-y-4">
                <div className="flex items-center space-x-3">
                  <Phone className="w-5 h-5 text-gray-400 flex-shrink-0" />
                  <a href="tel:+16308661646" className="text-gray-300 hover:text-blue-400 transition-colors">
                    +1 (630) 866-1646
                  </a>
                </div>
                <div className="flex items-center space-x-3">
                  <Mail className="w-5 h-5 text-gray-400 flex-shrink-0" />
                  <a href="mailto:lab2@acedentalcenter.com" className="text-gray-300 hover:text-blue-400 transition-colors">
                    Lab2@acedentalcenter.com
                  </a>
                </div>
                <div className="flex items-center space-x-3">
                  <Instagram className="w-5 h-5 text-gray-400 flex-shrink-0" />
                  <a href="https://www.instagram.com/acedentallab?igsh=MWIxOTh4ZTYzeGQ4Mg=="
                  target="_blank"
                  rel="noopener noreferrer" className="text-gray-300 hover:text-blue-400 transition-colors">
                    @acedentallab
                  </a>
                </div>
                <div className="flex items-start space-x-3">
                  <MapPin className="w-5 h-5 text-gray-400 mt-0.5 flex-shrink-0" />
                  <div className="text-gray-300">
                    <div>501 E Roosevelt Road</div>
                    <div>Lombard, Illinois 60148</div>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <Clock className="w-5 h-5 text-gray-400 mt-0.5 flex-shrink-0" />
                  <div className="text-gray-300">
                    <div>Mon-Fri: 8:30AM - 4:30PM</div>
                    <div>Saturday: 9:00AM - 2:00PM</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        {/* </div> */}
      </section>



      {/* Why Partner With Us Section  bg-white border-t border-gray-200 */}
      {/* style={{ backgroundImage: "url('/Images/bg blackedit.jpg')" }} */}
<section className="py-24 bg-black "   >
  <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">

    <div className="text-center mb-12">
      <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
        Why Partner With Ace Dental Lab?
      </h2>
      <p className="text-lg text-white max-w-3xl mx-auto leading-relaxed">
        We believe every clinic deserves a reliable lab partner—someone who
        understands your patients’ needs, supports your workflow, and consistently
        delivers excellence. At Ace Dental Lab, we focus on communication, 
        craftsmanship, and trust.
      </p>
    </div>

    <div className="space-y-10">

      <div className="bg-slate-50 p-8 rounded-2xl border border-gray-200 shadow-sm hover:shadow-md transition-all duration-200">
        <h3 className="text-2xl font-semibold text-black mb-3">Reliable Turnaround Times</h3>
        <p className="text-black leading-relaxed">
          We understand the importance of predictable scheduling. Our team works 
          with precision timelines to ensure your cases are delivered consistently 
          and without delays.
        </p>
      </div>

      <div className="bg-slate-50 p-8 rounded-2xl border border-gray-200 shadow-sm hover:shadow-md transition-all duration-200">
        <h3 className="text-2xl font-semibold text-black mb-3">Clear Communication</h3>
        <p className="text-black leading-relaxed">
          Whether it’s case details, adjustments, or special requests—we keep the 
          conversation open, fast, and professional. No confusion. No guesswork.
        </p>
      </div>

      <div className="bg-slate-50 p-8 rounded-2xl border border-gray-200 shadow-sm hover:shadow-md transition-all duration-200">
        <h3 className="text-2xl font-semibold text-black mb-3">Dedicated Support</h3>
        <p className="text-black leading-relaxed">
          Our team is committed to assisting your practice with everything from 
          case planning to delivery. We’re always ready to guide and support you 
          whenever needed.
        </p>
      </div>

    </div>

  </div>
</section>










     

      {/* Map Section */}
       {/* bg-gradient-to-r */}
      <section className="py-20 to-black-50  bg-black "> 
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
            <div className="bg-black from-gray-600 to-cyan-500 p-8 text-white text-center">
              <MapPin className="w-12 h-12 mx-auto mb-4" />
              <h3 className="text-2xl font-bold mb-2 text-white  ">Visit Our Lab</h3>
              <p className="text-white">
                501 E Roosevelt Road, Lombard, Illinois 60148
              </p>
            </div>

            <div className="p-8">
              <div className="grid md:grid-cols-3 gap-8 text-center">
                <div>
                  <Phone className="w-8 h-8 text-black  -600 mx-auto mb-3" />
                  <h4 className="font-semibold text-gray-900 mb-2">Call Us</h4>
                  <p className="text-gray-600">(630) 866-1646</p>
                </div>
                <div>
                  <Mail className="w-8 h-8 text-black-600 mx-auto mb-3" />
                  <h4 className="font-semibold text-gray-900 mb-2">Email Us</h4>
                  <a href="mailto: lab2@acedentalcenter.com">
                  Lab2@acedentalcenter.com
                </a>
                </div>
                <div>
                  <Clock className="w-8 h-8 text-black-600 mx-auto mb-3" />
                  <h4 className="font-semibold text-gray-900 mb-2">Hours</h4>
                  <div className="text-gray-600">
                    <div>Mon-Fri: 8:30AM - 4:30PM</div>
                    <div>Saturday: 9:00AM - 2:00PM</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      {/* bg-gradient-to-br  from-slate-900 via-blue-900 to-slate-900 */}
      {/* <section className="py-20 bg-gray-400    ">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl font-bold text-black mb-6">
            We combine innovation, precision, and personalized care
          </h2>
          <h3 className="text-2xl font-semibold text-black-400 mb-8">
            We Are Here to Elevate Your Dental Practice
          </h3>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:+16308661646"
              // bg-gradient-to-r
              className="inline-flex items-center bg-black  from-blue-600 to-cyan-500 text-white px-8 py-4 rounded-lg font-medium hover:from-blue-700 hover:to-cyan-600 transition-all duration-200 group"
            >
              <Phone className="mr-2 w-5 h-5" />
              Call Now
            </a>
            <a
              href="mailto:Lab@acedentalcenter.com"
              // transition-all
              className="inline-flex items-center border-2 bg-black  text-white  border-black-400 text-white-400 px-8 py-4 rounded-lg font-medium hover:bg-black-400 hover:text-white  duration-200"
            >
              <Mail className="mr-2 w-5 h-5" />
              Email Us
            </a>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default ContactPage;
